import { translations as selfServiceOrderTranslations } from '@storefront-satch/lib/self-service/translations'
import { translate } from 'internal/translate'

const baseTranslations = {
  en: {
    toProduct: 'To product',
    navigation: {
      search: { input: 'Enter search term...', placeholder: 'Search' },
    },
    cart: {
      headline: 'Shopping Cart',
      isEmpty: 'Your cart is empty',
      items: '{value} items',
      productRecommendation: {
        headline: 'Recommended products for you',
      },
      summary: {
        headline: 'Summary',
        returnsAndRefund: 'Returns and Refund',
        shippingCosts: 'Shipping Costs',
        total: 'Total',
        taxDetails: 'incl. VAT',
        taxDetailsWithoutDuties:
          'Additional VAT, customs duties or other charges such as customs clearance costs may apply',
        discount: 'Discount',
        shipping: 'Shipping',
        shippingBy: 'Shipping by',
        orderSum: 'Sum',
        proceedToCheckout: 'Proceed to Checkout',
      },
      cartCode: {
        question: 'Voucher or discount code?',
        apply: 'Apply',
        placeholder: 'Code',
      },
      cartItems: {
        deliveryTime: 'Delivery {deliveryRange} with DPD',
        deliveryRangeDefault: '2-4 working days',
      },
      counter: {
        amount: 'Amount',
        productAmount: 'Product amount',
        decreaseAmount: 'Decrease product amount',
        increaseAmount: 'Increase product amount',
        removeProduct: 'Remove product',
      },
    },
    yourEmail: 'Your email',
    subscribeToBackInStock: {
      success: 'Thank you!',
      error: 'Something went wrong! Please try again later.',
    },
    subscribe: 'Subscribe',
    internalServerError: {
      backToHome: 'Back to Home',
      headline: 'Oops! Something has gone wrong.',
      subline: 'The request could not be processed. Please try again later.',
    },
    carousel: {
      button: {
        prev: 'To previous page',
        next: 'To next page',
      },
    },
    required: 'Required',
    cancel: 'Cancel',
    shippingAddress: 'Shipping Address',
    billingAddress: 'Billing Address',
    return: {
      error: {
        headline: 'Return label could not be created automatically',
        description: 'Create your free returns label manually with DHL.',
        createManual: 'Create return label manually',
        backToOrders: 'Back to my orders',
      },
      success: {
        costly: {
          headline: 'Send the return with sufficient postage to:',
          germany: 'Germany',
          street: 'Heinrich-Barth-Strasse 16',
          info: 'Returns outside Germany, Switzerland and Italy are at your own expense.',
        },
        headline: 'Returns are registered.',
        description: ['We have sent you the summary with return label to'],
        yourReturn: 'Your return',
        orderNumber: 'Order number',
        downloadButton: 'Download returns label',
        myOrders: 'To my Orders',
      },
      address: {
        title: 'Select Sender Address',
        info: 'We will send the package back to this address if it does not reach us.',
      },
      products: {
        title: 'Select Items',
        ownCostInfo:
          'Returns outside of Germany, Switzerland and Italy are at your own expense.',
        selectReturnReasons: 'Return reasons must be filled out.',
        selectReturnReason: 'Select return reason',
        defaultReturnError:
          'The return could not be completed. Please try again later.',
        batteryPackagingInfo:
          'I confirm that I have read the information on batteries and that the batteries are undamaged (mandatory field)',
      },
      reasons: [
        'Ordered several items to choose from',
        'I do not like this article',
        'Article too big',
        'Article too small',
        'Backpack volume too small',
        'Different than shown',
        'Wrong item delivered',
        'Item delivered too late',
        'Damaged product',
        'Other',
      ],
      reason: 'Return reason',
    },
    confirmCustomer: {
      success: 'Your email has been successfully verified.',
      error: 'Your verification failed. Please contact info@satch.com',
    },
    back: 'back',
    search: 'Search',
    searchResult: 'Search result',
    apply: 'Apply',
    meta: {
      products: { title: 'Search Products | satch' },
      info: { title: 'Search Info | satch' },
      description:
        'Official satch online shop ★ satch school backpacks combine the ergonomic concept with individuality and environmental awareness ★ Shipping worldwide ✔ Warranty provided ✔ Sustainable textiles made from 100% upcycled PET bottles ✔',
    },
    filter: {
      resetAll: 'Reset All',
      DEFAULT: 'Filter',
      title: 'Filter',
      sort: 'Sorting',
      'price-DEFAULT-EUR-GROSS_MODE': 'Price',
      edition: 'Special Edition',
      bestseller: 'Bestseller',
    },
    close: 'Close',
    price: {
      DEFAULT: 'Price',
      price_asc: 'Price ascending',
      price_desc: 'Price descending',
    },
    productView: {
      all: 'All',
      styleSwitcher: {
        title: 'Choose style',
      },
    },
    noResults: {
      DEFAULT: 'No matches found',
      headline: 'Sorry, we could not find any results.',
      content: "Don't give up. Try again with different words.",
      noInfoResults:
        'Currently, there is no further content available at this location.',
      noProductResults:
        "We searched everywhere: Unfortunately, we couldn't find a suitable product.",
      searchInstead: 'Did you mean',
    },
    pagination: {
      showPrevious: 'Show Previous',
      showMore: 'Show More',
      productsSeen: '{amount} of {limit} products seen',
    },
    products: 'Products',
    info: 'Info',
    product: {
      addToCart: 'add to cart',
      addToCartAtWishlist: 'Cart',
      atCart: 'At cart',
      comingSoon: 'coming soon',
      availableAt: 'available at',
      availableAgainAt: 'available at',
      soldOut: 'sold out',
      new: 'new',
      sale: 'sale',
      free: 'free',
      voucher: 'voucher',
      property: {
        details: 'Product details',
        features: 'Features',
        material: 'Material',
        safetyAndConformity: 'Safety and conformity',
        responsibility: 'Responsibility',
        articleNo: 'Art. No.',
        color: 'Color',
        content: 'Content',
        weight: 'Weight',
        volume: 'Volume',
        size: 'Size',
        sizeInfo: 'W/H/D',
        liter: 'liter',
      },
    },
    titlePageNotFound: 'Page not found - 404',
  },
  de: {
    toProduct: 'Zum Produkt',
    navigation: {
      search: { input: 'Suchbegriff eingeben...', placeholder: 'Suche' },
    },
    cart: {
      headline: 'Warenkorb',
      isEmpty: 'Dein Warenkorb ist leer.',
      items: '{value} Artikel',
      productRecommendation: {
        headline: 'Empfohlene Produkte für dich',
      },
      summary: {
        headline: 'Gesamtsumme',
        shippingCosts: '* Versandkosten',
        returnsAndRefund: 'Rückgabe und Erstattung',
        total: 'Gesamt',
        taxDetails: 'inkl. gesetzl. MwSt',
        taxDetailsWithoutDuties:
          'Es können zusätzliche Mehrwertsteuer, Zölle oder andere Abgaben wie Verzollungskosten anfallen',
        discount: 'Rabatt',
        shipping: 'Versand',
        shippingBy: 'Versand durch',
        orderSum: 'Bestellsumme',
        proceedToCheckout: 'Zur Kasse',
      },
      cartCode: {
        question: 'Gutschein- oder Rabattcode?',
        apply: 'Einlösen',
        placeholder: 'Code',
      },
      cartItems: {
        deliveryTime: 'Lieferung {deliveryRange} mit DHL',
        deliveryRangeDefault: '2–4 Werktage',
      },
      counter: {
        amount: 'Anzahl',
        productAmount: 'Produktanzahl',
        decreaseAmount: 'Produktanzahl verringern',
        increaseAmount: 'Produktanzahl erhöhen',
        removeProduct: 'Produkt entfernen',
      },
    },
    yourEmail: 'Deine E-Mail',
    subscribe: 'Anmelden',
    subscribeToBackInStock: {
      success: 'Vielen Dank!',
      error: 'Etwas ist schief gelaufen! Bitte versuche es später erneut.',
    },
    internalServerError: {
      backToHome: 'Zurück zur Startseite',
      headline: 'Oops! Etwas ist schief gelaufen.',
      subline:
        'Die Anfrage konnte nicht verarbeitet werden. Bitte versuche es später erneut.',
    },
    carousel: {
      button: {
        prev: 'Zur vorherigen Seite',
        next: 'Zur nächsten Seite',
      },
    },
    required: 'Pflichtfeld',
    cancel: 'Abbrechen',
    shippingAddress: 'Lieferadresse',
    billingAddress: 'Rechnungsadresse',
    return: {
      error: {
        headline: 'Retourenlabel konnte nicht automatisch erstellt werden',
        description:
          'Erstelle dir manuell dein kostenloses Retourenlabel mit DHL.',
        createManual: 'Retourenlabel manuell erstellen',
        backToOrders: 'Zurück zu meinen Bestellungen',
      },
      success: {
        costly: {
          headline: 'Schicke die Retoure ausreichend frankiert an:',
          germany: 'Deutschland',
          street: 'Heinrich-Barth-Straße 16',
          info: 'Retouren außerhalb von Deutschland, Schweiz und Italien erfolgen auf eigene Kosten.',
        },
        headline: 'Retoure ist angemeldet.',
        description: [
          'Wir haben dir die Zusammenfassung mit Retourenlabel an',
          'geschickt.',
        ],
        yourReturn: 'Deine Retoure',
        orderNumber: 'Bestellnummer',
        downloadButton: 'Retourenlabel herunterladen',
        myOrders: 'Zu meinen Bestellungen',
      },
      address: {
        title: 'Absender-Adresse auswählen',
        info: 'Wir schicken das Paket an diese Adresse zurück, falls es uns nicht erreicht.',
      },
      products: {
        title: 'Artikel auswählen',
        ownCostInfo:
          'Retouren außerhalb von Deutschland, Schweiz und Italien erfolgen auf eigene Kosten.',
        selectReturnReasons: 'Retourengründe müssen ausgefüllt sein.',
        selectReturnReason: 'Retourengrund auswählen',
        defaultReturnError:
          'Die Retoure konnte nicht abgeschlossen werden. Bitte versuche es später erneut.',
        batteryPackagingInfo:
          'Ich versichere, dass ich die Informationen zu Batterien zur Kenntnis genommen habe und die Batterien unbeschädigt sind (Pflichtfeld)',
      },
      reasons: [
        'Mehrere Artikel zur Auswahl bestellt',
        'Artikel gefällt nicht',
        'Artikel zu groß',
        'Artikel zu klein',
        'Zu geringes Rucksackvolumen',
        'Anders als dargestellt',
        'Falscher Artikel geliefert',
        'Artikel zu spät geliefert',
        'Beschädigtes Produkt',
        'Sonstiges',
      ],
      reason: 'Retourengrund',
    },
    confirmCustomer: {
      success: 'Deine E-Mail wurde erfolgreich verifiziert.',
      error:
        'Deine Verifizierung ist fehlgeschlagen. Bitte wende dich an info@satch.com.',
    },
    back: 'zurück',
    search: 'Suchen',
    searchResult: 'Suchergebnis',
    meta: {
      products: { title: 'Suche Produkte | satch' },
      info: { title: 'Suche Info | satch' },
      description:
        'Du möchtest Qualität, die etwas miterleben kann? satch bietet smarte Funktionen und angesagte Styles, die man mit einem guten Gefühl tragen kann.',
    },
    apply: 'Speichern',
    filter: {
      resetAll: 'Alle Zurücksetzen',
      sort: 'Sortieren',
      DEFAULT: 'Filter',
      title: 'Filtern',
      'price-DEFAULT-EUR-GROSS_MODE': 'Preis',
      edition: 'Special Edition',
      bestseller: 'Bestseller',
    },
    close: 'Schließen',
    price: {
      DEFAULT: 'Preis',
      price_asc: 'Preis aufsteigend',
      price_desc: 'Preis absteigend',
    },
    productView: {
      all: 'Alle',
      styleSwitcher: {
        title: 'Style wählen',
      },
    },
    noResults: {
      DEFAULT: 'Keine Treffer gefunden',
      headline: 'Wir konnten leider keine Treffer finden.',
      content: 'Nicht aufgeben. Versuche es nochmal mit anderen Worten.',
      noInfoResults: 'Aktuell gibt es an dieser Stelle keine weiteren Inhalte.',
      noProductResults:
        'Wir haben überall gesucht: Leider haben wir kein passendes Produkt.',
      searchInstead: 'Meintest du',
    },
    pagination: {
      showPrevious: 'Vorherige Anzeigen',
      showMore: 'Mehr Anzeigen',
      productsSeen: '{amount} von {limit} Produkten gesehen',
    },
    products: 'Produkte',
    info: 'Infos',
    product: {
      addToCart: 'hinzufügen',
      addToCartAtWishlist: 'Warenkorb',
      atCart: 'Im Warenkorb',
      comingSoon: 'coming soon',
      availableAt: 'verfügbar ab',
      availableAgainAt: 'wieder verfügbar ab',
      soldOut: 'ausverkauft',
      new: 'new',
      sale: 'sale',
      free: 'free',
      voucher: 'Gutschein',
      property: {
        details: 'Produktdetails',
        features: 'Features',
        material: 'Material',
        safetyAndConformity: 'Sicherheit und Konformität',
        responsibility: 'Verantwortung',
        articleNo: 'Art. Nr.',
        color: 'Farbe',
        content: 'Inhalt',
        weight: 'Gewicht',
        volume: 'Volumen',
        size: 'Größe',
        sizeInfo: 'B/H/T',
        liter: 'Liter',
      },
    },
    titlePageNotFound: 'Seite nicht gefunden - 404',
  },
  fr: {
    toProduct: 'Au produit',
    navigation: {
      search: {
        input: 'Entrer le terme recherché...',
        placeholder: 'Recherche',
      },
    },
    cart: {
      headline: 'Panier',
      isEmpty: 'Votre panier est vide.',
      items: '{value} articles',
      productRecommendation: {
        headline: 'Produits recommandés pour vous',
      },
      summary: {
        headline: 'Résumé',
        returnsAndRefund: 'Retours et remboursements',
        shippingCosts: 'Frais de port',
        total: 'Total',
        taxDetails: 'incl. TVA',
        taxDetailsWithoutDuties:
          "Des frais supplémentaires de TVA, de droits de douane ou d'autres charges, tels que les frais de dédouanement, peuvent s'appliquer",
        discount: 'Remise',
        shipping: 'Expédition',
        shippingBy: 'Expédié par',
        orderSum: 'Somme de la commande',
        proceedToCheckout: 'Passer à la caisse',
      },
      cartCode: {
        question: "Code de réduction ou de bon d'achat ?",
        apply: 'Appliquer',
        placeholder: 'Code',
      },
      cartItems: {
        deliveryTime: 'Livraison {deliveryRange} avec DPD',
        deliveryRangeDefault: '2-4 jours ouvrables',
      },
      counter: {
        amount: 'Quantité',
        productAmount: 'Quantité de produit',
        increaseAmount: 'Augmenter la quantité',
        decreaseAmount: 'Diminuer la quantité',
        removeProduct: 'Retirer le produit',
      },
    },
    yourEmail: 'Votre e-mail',
    subscribe: "S'inscrire",
    subscribeToBackInStock: {
      success: 'Merci!',
      error: 'Quelque chose s’est mal passé! Veuillez réessayer plus tard.',
    },
    internalServerError: {
      backToHome: 'Retour à la page d’accueil',
      headline: 'Oops! Quelque chose s’est mal passé.',
      subline:
        'La demande n’a pas pu être traitée. Veuillez réessayer plus tard.',
    },
    carousel: {
      button: {
        prev: 'Page précédente',
        next: 'Page suivante',
      },
    },
    required: 'Champ obligatoire',
    cancel: 'Annuler',
    shippingAddress: 'Adresse de livraison',
    billingAddress: 'Adresse de facturation',
    return: {
      error: {
        headline: 'L’étiquette de retour n’a pas pu être créée automatiquement',
        description:
          'Créez manuellement votre étiquette de retour gratuite avec DHL.',
        createManual: 'Créer l’étiquette de retour manuellement',
        backToOrders: 'Retour à mes commandes',
      },
      success: {
        costly: {
          headline: 'Envoie le retour suffisamment affranchi à :',
          germany: 'Allemagne',
          street: 'Heinrich-Barth-Strasse 16',
          info: "Les retours en dehors de l'Allemagne, de la Suisse et de l'Italie se font aux frais de l'acheteur.",
        },
        headline: 'Le retour est enregistré.',
        description: [
          "Nous t'avons envoyé le récapitulatif avec l'étiquette de retour à",
        ],
        yourReturn: 'Ton retour',
        orderNumber: 'Numéro de commande',
        downloadButton: "Télécharger l'étiquette de retour",
        myOrders: 'Voir mes commandes',
      },
      address: {
        title: "Sélectionner l'adresse de l'expéditeur",
        info: "Nous renverrons le colis à cette adresse s'il ne nous parvient pas.",
      },
      products: {
        title: 'Sélectionner les articles',
        ownCostInfo:
          "Les retours en dehors de l'Allemagne, de la Suisse et de l'Italie sont à vos frais.",
        selectReturnReasons: 'Les raisons du retour doivent être remplies.',
        selectReturnReason: 'Sélectionner la raison du retour',
        defaultReturnError:
          "Le retour n'a pas pu être effectué. Veuillez réessayer plus tard.",
        batteryPackagingInfo:
          'Je certifie avoir pris connaissance des informations relatives aux piles et que les piles sont intactes (champ obligatoire)',
      },
      reasons: [
        'Plusieurs articles commandés pour choisir',
        "Je n'aime pas cet article",
        'Article trop grand',
        'Article trop petit',
        'Volume du sac à dos trop petit',
        'Différent de celui montré',
        'Mauvais article livré',
        'Article livré trop tard',
        'Produit endommagé',
        'Autre',
      ],
      reason: 'Raison du retour',
    },
    confirmCustomer: {
      success: 'Votre e-mail a été vérifié avec succès.',
      error: 'Votre vérification a échoué. Veuillez contacter info@satch.com',
    },
    back: 'retour',
    search: 'Rechercher',
    searchResult: 'Résultats',
    meta: {
      products: { title: 'Recherche de produits | satch' },
      info: { title: 'Recherche de Info | satch' },
      description:
        'E-shop officel de satch ★ Les sac à dos satch pour l’école misent sur l’ergonomie, l’individualité et la conscience écologique ★ Expédition mondiale ✔ Garantie fournie ✔ Textiles qui sont produit à 100 % à base de bouteilles PET recyclées ✔',
    },
    apply: 'Appliquer',
    filter: {
      resetAll: 'Réinitialiser tout',
      sort: 'Tri',
      DEFAULT: 'Filtre',
      title: 'Filtrer & Trier',
      'price-DEFAULT-EUR-GROSS_MODE': 'Prix',
      edition: 'Special Edition',
      bestseller: 'Bestseller',
    },
    close: 'Fermer',
    price: {
      DEFAULT: 'Prix',
      price_asc: 'Prix droissant',
      price_desc: 'Prix décroissant',
    },
    productView: {
      all: 'Tous',
      styleSwitcher: {
        title: 'Choisir le style',
      },
    },
    noResults: {
      DEFAULT: "Aucun résultat n'a été trouvé",
      headline: "Désolé, nous n'avons pas trouvé de résultats.",
      content: "N'abandonnez pas. Essaye encore une fois avec d'autres mots.",
      noInfoResults:
        "Actuellement, il n'y a pas d'autres contenus disponibles à cet emplacement.",
      noProductResults:
        "Nous avons cherché partout : malheureusement, nous n'avons pas trouvé de produit adapté.",
      searchInstead: 'Vouliez-vous dire',
    },
    pagination: {
      showPrevious: 'Afficher les précédents',
      showMore: 'Voir plus',
      productsSeen: '{amount} vu par {limit} produits',
    },
    products: 'Produits',
    info: 'Info',
    product: {
      addToCart: 'Ajouter au panier',
      addToCartAtWishlist: 'Panier',
      atCart: 'Dans le panier',
      comingSoon: 'coming soon',
      availableAt: 'disponible le',
      availableAgainAt: 'disponible le',
      soldOut: 'sold out',
      new: 'new',
      sale: 'sale',
      free: 'free',
      voucher: 'Bon',
      property: {
        details: 'Détails du produit',
        features: 'Fonctions',
        material: 'Matériel',
        safetyAndConformity: 'Sécurité et conformité',
        responsibility: 'Responsabilité',
        articleNo: 'Art. No.',
        color: 'Couleur',
        content: 'Content',
        weight: 'Poids',
        volume: 'Volume',
        size: 'Dimensions',
        sizeInfo: 'L/P/H',
        liter: 'litre',
      },
    },
    titlePageNotFound: 'Page non trouvée - 404',
  },
  it: {
    toProduct: 'Al prodotto',
    navigation: {
      search: {
        input: 'Inserisci il termine di ricerca...',
        placeholder: 'Cerca',
      },
    },
    cart: {
      headline: 'Carrello',
      isEmpty: 'Il tuo carrello è vuoto.',
      items: '{value} articoli',
      productRecommendation: {
        headline: 'Prodotti consigliati per te',
      },
      summary: {
        headline: 'Riepilogo',
        returnsAndRefund: 'Resi e rimborsi',
        shippingCosts: 'Spese di spedizione',
        total: 'Totale',
        taxDetails: 'incl. IVA',
        taxDetailsWithoutDuties:
          'Potrebbero essere applicati costi aggiuntivi per IVA, dazi doganali o altre spese, come i costi di sdoganamento',
        discount: 'Sconto',
        shipping: 'Spedizione',
        shippingBy: 'Spedito da',
        orderSum: "Somma dell'ordine",
        proceedToCheckout: 'Procedi al pagamento',
      },
      cartCode: {
        question: 'Codice sconto o voucher?',
        apply: 'Applica',
        placeholder: 'Codice',
      },
      cartItems: {
        deliveryTime: 'Consegna {deliveryRange} con DPD',
        deliveryRangeDefault: '2-4 giorni lavorativi',
      },
      counter: {
        amount: 'Quantità',
        productAmount: 'Quantità di prodotto',
        increaseAmount: 'Aumenta la quantità',
        decreaseAmount: 'Diminuisci la quantità',
        removeProduct: 'Rimuovi il prodotto',
      },
    },
    yourEmail: 'La tua email',
    subscribe: 'Iscriviti',
    subscribeToBackInStock: {
      success: 'Grazie!',
      error: 'Qualcosa è andato storto! Riprova più tardi.',
    },
    internalServerError: {
      backToHome: 'Torna alla pagina iniziale',
      headline: 'Oops! Qualcosa è andato storto.',
      subline: 'La richiesta non può essere elaborata. Riprova più tardi.',
    },
    carousel: {
      button: {
        prev: 'Pagina precedente',
        next: 'Pagina successiva',
      },
    },
    required: 'Campo obbligatorio',
    cancel: 'Annulla',
    shippingAddress: 'Indirizzo di spedizione',
    billingAddress: 'Indirizzo di fatturazione',
    return: {
      error: {
        headline: 'L’etichetta di reso non è stata creata automaticamente',
        description:
          'Crea manualmente la tua etichetta di reso gratuita con DHL.',
        createManual: 'Crea etichetta di reso manualmente',
        backToOrders: 'Torna ai miei ordini',
      },
      success: {
        costly: {
          headline: "Inviare il reso con l'affrancatura sufficiente a:",
          germany: 'Germania',
          street: 'Heinrich-Barth-Strasse 16',
          info: "Le restituzioni al di fuori della Germania, della Svizzera e dell'Italia sono a carico del cliente.",
        },
        headline: 'I resi sono registrati.',
        description: [
          "Vi abbiamo inviato il riepilogo con l'etichetta di restituzione a",
        ],
        yourReturn: 'Il vostro ritorno',
        orderNumber: "Numero d'ordine",
        downloadButton: "Scarica l'etichetta di reso",
        myOrders: 'Ai miei ordini',
      },
      address: {
        title: "Seleziona l'indirizzo del mittente",
        info: 'In caso di mancato recapito, spediremo il pacco a questo indirizzo.',
      },
      products: {
        title: 'Seleziona articoli',
        ownCostInfo:
          'I resi al di fuori di Germania, Svizzera e Italia sono a tuo carico.',
        selectReturnReasons: 'I motivi del reso devono essere compilati.',
        selectReturnReason: 'Seleziona il motivo del reso',
        defaultReturnError:
          'Il reso non è stato completato. Si prega di riprovare più tardi.',
        batteryPackagingInfo:
          'Confermo di aver letto le informazioni sulle batterie e che le batterie non sono danneggiate (campo obbligatorio)',
      },
      reasons: [
        'Ordinato più articoli per scegliere',
        'Non mi piace questo articolo',
        'Articolo troppo grande',
        'Articolo troppo piccolo',
        'Volume dello zaino troppo piccolo',
        'Diverso da quello mostrato',
        'Articolo sbagliato consegnato',
        'Articolo consegnato troppo tardi',
        'Prodotto danneggiato',
        'Altro',
      ],
      reason: 'Motivo del reso',
    },
    confirmCustomer: {
      success: 'La tua email è stata verificata con successo.',
      error:
        'La tua verifica non è riuscita. Si prega di contattare info@satch.com',
    },
    back: 'indietro',
    search: 'Ricerca',
    searchResult: 'Risultati',
    meta: {
      products: { title: 'Ricerca prodotti | satch' },
      info: { title: 'Ricerca informazioni | satch' },
      description:
        "Collezione attuale ☚ Shop online ufficiale ★ Accessori e zaini per la scuola ✎ Ergonomico e responsabile ✔ Realizzato con bottiglie di PET riciclate al 100% ✔Zaini sostenibili per l'asilo, scarpe barefoot, abbigliamento e accessori con tante funzioni e disegni di animali. Per bambini da 0-7 anni. ✓ Ampia scelta ✓ Negozio ufficiale",
    },
    apply: 'Applicare',
    filter: {
      resetAll: 'Azzerare tutto',
      sort: 'Ordinamento',
      DEFAULT: 'Filtro',
      title: 'Filtro',
      'price-DEFAULT-EUR-GROSS_MODE': 'Prezzo',
      edition: 'Special Edition',
      bestseller: 'Bestseller',
    },
    close: 'Chiudi',
    price: {
      DEFAULT: 'prezzo',
      price_asc: 'Prezzo crescente',
      price_desc: 'Prezzo decrescente',
    },
    productView: {
      all: 'Tutto',
      styleSwitcher: {
        title: 'Scegli lo stile',
      },
    },
    noResults: {
      DEFAULT: 'Nessuna corrispondenza trovata',
      headline: 'Spiacenti, non abbiamo trovato alcun risultato',
      content: 'Non arrenderti. Riprova con parole diverse.',
      noInfoResults:
        'Attualmente, non ci sono ulteriori contenuti disponibili in questo punto.',
      noProductResults:
        'Abbiamo cercato ovunque: sfortunatamente non abbiamo trovato un prodotto adatto.',
      searchInstead: 'Intendevi dire',
    },
    pagination: {
      showPrevious: 'Mostra precedente',
      showMore: 'Mostra di più',
      productsSeen: '{amount} di {limit} prodotti visti',
    },
    products: 'Prodotti',
    info: 'Info',
    product: {
      addToCart: 'Aggiungi',
      addToCartAtWishlist: 'Carrello',
      atCart: 'Nel carrello',
      comingSoon: 'prossimamente',
      availableAt: 'Disponibile da',
      availableAgainAt: 'Di nuovo disponibile dal',
      soldOut: 'esaurito',
      voucher: 'Buoni',
      new: 'new',
      sale: 'sale',
      free: 'free',
      property: {
        details: 'Dettagli del prodotto',
        features: 'Funzioni',
        material: 'Materiale',
        safetyAndConformity: 'Sécurité et conformité',
        responsibility: 'Responsabilità',
        articleNo: 'Art.-Nr.',
        color: 'Colore',
        content: 'Content',
        weight: 'Peso',
        volume: 'Volume',
        size: 'Taglia',
        sizeInfo: 'L/P/H',
        liter: 'litro',
      },
    },
    titlePageNotFound: 'Pagina non trovata - 404',
  },
  da: {
    toProduct: 'Til produkt',
    navigation: {
      search: { input: 'Indtast søgeord...', placeholder: 'Søg' },
    },
    cart: {
      headline: 'Indkøbskurv',
      isEmpty: 'Din indkøbskurv er tom.',
      items: '{value} artikler',
      productRecommendation: {
        headline: 'Anbefalede produkter til dig',
      },
      summary: {
        headline: 'Sammendrag',
        returnsAndRefund: 'Retur og refusion',
        shippingCosts: 'Fragtomkostninger',
        total: 'Total',
        taxDetails: 'inkl. moms',
        taxDetailsWithoutDuties:
          'Der kan gælde yderligere omkostninger til moms, told eller andre gebyrer, såsom toldbehandlingsgebyrer',
        discount: 'Rabatt',
        shipping: 'Fragt',
        shippingBy: 'Forsendt af',
        orderSum: 'Ordre sum',
        proceedToCheckout: 'Gå til kassen',
      },
      cartCode: {
        question: 'Voucher eller rabatkode?',
        apply: 'Anvend',
        placeholder: 'Code',
      },
      cartItems: {
        deliveryTime: 'Levering {deliveryRange} med DPD',
        deliveryRangeDefault: '2-4 arbejdsdage',
      },
      counter: {
        amount: 'Antal',
        productAmount: 'Produktantal',
        decreaseAmount: 'Formindsk produktmængde',
        increaseAmount: 'Forøg produktmængde',
        removeProduct: 'Fjern produkt',
      },
    },
    yourEmail: 'Din e-mail',
    subscribe: 'Tilmeld',
    subscribeToBackInStock: {
      success: 'Tak!',
      error: 'Noget gik galt! Prøv venligst igen senere.',
    },
    internalServerError: {
      backToHome: 'Tilbage til startsiden',
      headline: 'Ups! Noget gik galt.',
      subline: 'Anmodningen kunne ikke behandles. Prøv venligst igen senere.',
    },
    carousel: {
      button: {
        prev: 'Til forrige side',
        next: 'Til næste side',
      },
    },
    required: 'Obligatorisk felt',
    cancel: 'Annuller',
    shippingAddress: 'Leveringsadresse',
    billingAddress: 'Faktureringsadresse',
    return: {
      error: {
        headline: 'Returlabel kunne ikke oprettes automatisk',
        description: 'Opret dit gratis returlabel manuelt med DHL.',
        createManual: 'Opret returlabel manuelt',
        backToOrders: 'Tilbage til mine ordrer',
      },
      success: {
        costly: {
          headline: 'Send returen med tilstrækkelig porto til:',
          germany: 'Tyskland',
          street: 'Heinrich-Barth-Straße 16',
          info: 'Returneringer uden for Tyskland, Schweiz og Italien er for egen regning',
        },
        headline: 'Returneringer registreres',
        description: ['Vi har sendt dig oversigten med returlabel til'],
        yourReturn: 'Din returnering',
        orderNumber: 'Ordrenummer',
        downloadButton: 'Download returlabel',
        myOrders: 'Til mine ordrer',
      },
      address: {
        title: 'Vælg afsenderadresse',
        info: 'Vi sender pakken tilbage til denne adresse, hvis den ikke når frem til os',
      },
      products: {
        title: 'Vælg vare',
        ownCostInfo:
          'Returneringer uden for Tyskland, Schweiz og Italien er for egen regning',
        selectReturnReasons: 'Returneringsårsager skal udfyldes',
        selectReturnReason: 'Vælg returårsag',
        defaultReturnError:
          'Returneringen kunne ikke gennemføres. Prøv venligst igen senere',
        batteryPackagingInfo:
          'Jeg bekræfter, at jeg har læst oplysningerne om batterier, og at batterierne er ubeskadigede (obligatorisk felt)',
      },
      reasons: [
        'Bestilte flere varer at vælge imellem',
        'Varen faldt ikke i min smag',
        'Varen er for stor',
        'Varen er for lille',
        'Rygsækkens volumen er for lille',
        'Andet end vist',
        'Forkert vare leveret',
        'Varen er leveret for sent',
        'Beskadiget produkt',
        'Andet',
      ],
      reason: 'Årsag til returnering',
    },
    search: 'Søg efter',
    searchResult: 'Søgeresultat',
    meta: {
      products: { title: 'Search Products | satch' },
      info: { title: 'Search Infos | satch' },
      description:
        'Officiel satch webshop ★ satch skolerygsækkene kombinerer ergonomisk pasform med individualitet og bæredygtighed ★ Levering over hele kloden ✔ Omfattet af garantien ✔ Bæredygtige tekstiler, der består 100% af genbrugte PET-flasker ✔',
    },
    apply: 'Anvend',
    filter: {
      resetAll: 'Nulstil alle',
      sort: 'Sortering',
      DEFAULT: 'Filter',
      title: 'Filter & Sortere',
      'price-DEFAULT-EUR-GROSS_MODE': 'Pris',
      bestseller: 'Bestseller',
    },
    close: 'Luk',
    price: {
      DEFAULT: 'pris',
      price_asc: 'Stigende pris',
      price_desc: 'Faldende pris',
    },
    productView: {
      all: 'alle',
      styleSwitcher: {
        title: 'Vælg stil',
      },
    },
    noResults: {
      DEFAULT: 'Ingen match fundet',
      headline: 'Beklager, vi kunne ikke finde nogen resultater.',
      content: 'Giv ikke op. Prøv igen med andre ord.',
      noInfoResults:
        'I øjeblikket er der ikke yderligere indhold tilgængeligt på dette sted.',
      noProductResults:
        'Vi har søgt overalt: Desværre kunne vi ikke finde et passende produkt.',
      searchInstead: 'Mente du',
    },
    pagination: {
      showPrevious: 'Vis tidligere',
      showMore: 'Vis mere',
      productsSeen: '{amount} af {limit} viste produkter',
    },
    products: 'Produkter',
    info: 'Info',
    product: {
      addToCart: 'Tilføj',
      addToCartAtWishlist: 'Kurv',
      atCart: 'I kurven',
      comingSoon: 'kommer snart',
      availableAt: 'ledig fra',
      availableAgainAt: 'tilgængelig igen fra',
      soldOut: 'udsolgt',
      new: 'new',
      sale: 'sale',
      free: 'free',
      voucher: 'Kupon',
      property: {
        details: 'Produkt detaljer',
        features: 'Funktioner',
        material: 'Materiale',
        safetyAndConformity: 'Sikkerhed og overensstemmelse',
        responsibility: 'Ansvar',
        articleNo: 'Art. nr.',
        color: 'Farve',
        content: 'Content',
        weight: 'Vægt',
        volume: 'Volumen',
        size: 'Mål',
        sizeInfo: 'B/D/H',
        liter: 'liter',
      },
    },
    titlePageNotFound: 'Siden blev ikke fundet - 404',
  },
  es: {
    toProduct: 'Al producto',
    navigation: {
      search: {
        input: 'Introducir término de búsqueda...',
        placeholder: 'Buscar',
      },
    },
    cart: {
      headline: 'Carrito de compras',
      isEmpty: 'Tu carrito está vacío.',
      items: '{value} artículos',
      productRecommendation: {
        headline: 'Productos recomendados',
      },
      summary: {
        headline: 'Resumen',
        returnsAndRefund: 'Devoluciones y reembolsos',
        shippingCosts: 'Costos de envío',
        total: 'Total',
        taxDetails: 'incl. IVA',
        taxDetailsWithoutDuties:
          'Potrebbero essere applicati costi aggiuntivi per IVA, dazi doganali o altre spese, come i costi di sdoganamento',
        discount: 'Sconto',
        shipping: 'Spedizione',
        shippingBy: 'Spedito da',
        orderSum: "Somma dell'ordine",
        proceedToCheckout: 'Procedi al pagamento',
      },
      cartCode: {
        question: '¿Código de descuento o cupón?',
        apply: 'Aplicar',
        placeholder: 'Código',
      },
      cartItems: {
        deliveryTime: 'Entrega {deliveryRange} con DPD',
        deliveryRangeDefault: '2-4 días laborables',
      },
      counter: {
        amount: 'Cantidad',
        productAmount: 'Cantidad de producto',
        increaseAmount: 'Aumentar cantidad',
        decreaseAmount: 'Disminuir cantidad',
        removeProduct: 'Eliminar producto',
      },
    },
    yourEmail: 'Tu correo electrónico',
    subscribe: 'Suscribirse',
    subscribeToBackInStock: {
      success: '¡Gracias!',
      error: '¡Algo ha ido mal! Inténtalo de nuevo más tarde.',
    },
    internalServerError: {
      backToHome: 'Volver a la página de inicio',
      headline: '¡Ups! Algo ha ido mal.',
      subline:
        'La solicitud no se puede procesar. Inténtalo de nuevo más tarde.',
    },
    carousel: {
      button: {
        prev: 'Página anterior',
        next: 'Página siguiente',
      },
    },
    required: 'Campo obligatorio',
    cancel: 'Cancelar',
    shippingAddress: 'Dirección de envío',
    billingAddress: 'Dirección de facturación',
    return: {
      error: {
        headline: 'No se pudo crear la etiqueta de devolución automáticamente',
        description:
          'Crea tu etiqueta de devolución gratuita manualmente con DHL.',
        createManual: 'Crear etiqueta de devolución manualmente',
        backToOrders: 'Volver a mis pedidos',
      },
      success: {
        costly: {
          headline: 'Enviar la devolución con franqueo suficiente a:',
          germany: 'Alemania',
          street: 'Heinrich-Barth-Straße 16',
          info: 'Las devoluciones fuera de Alemania, Suiza e Italia corren por su cuenta',
        },
        headline: 'Las devoluciones se registran',
        description: [
          'Le hemos enviado el resumen con etiqueta de devolución a',
        ],
        yourReturn: 'Su devolución',
        orderNumber: 'Número de pedido',
        downloadButton: 'Descargar etiqueta de devolución',
        myOrders: 'A mis pedidos',
      },
      address: {
        title: 'Seleccionar dirección del remitente',
        info: 'Enviaremos el paquete de vuelta a esta dirección si no nos llega',
      },
      products: {
        title: 'Seleccionar artículo',
        ownCostInfo:
          'Las devoluciones fuera de Alemania, Suiza e Italia corren por su cuenta',
        selectReturnReasons: 'Los motivos de devolución deben rellenarse',
        selectReturnReason: 'Seleccione el motivo de devolución',
        defaultReturnError:
          'No se ha podido completar la devolución. Inténtelo de nuevo más tarde',
        batteryPackagingInfo:
          'Confirmo que he leído la información sobre las pilas y que las pilas no están dañadas (campo obligatorio)',
      },
      reasons: [
        'Pedí varios artículos para elegir',
        'Artículo no de mi agrado',
        'Artículo demasiado grande',
        'Artículo demasiado pequeño',
        'Volumen de la mochila demasiado pequeño',
        'Otro distinto al mostrado',
        'Artículo entregado incorrecto',
        'Artículo entregado demasiado tarde',
        'Producto dañado',
        'Otro',
      ],
      reason: 'Motivo de la devolución',
    },
    search: 'Búsqueda',
    searchResult: 'Resultado de la búsqueda',
    aplicar: 'Aplicar',
    meta: {
      products: { title: 'Search Products | satch' },
      info: { title: 'Search Info | satch' },
      description:
        'Official satch online shop ★ satch school backpacks combine the ergonomic concept with individuality and environmental awareness ★ Shipping worldwide ✔ Warranty provided ✔ Sustainable textiles made from 100% upcycled PET bottles ✔',
    },
    filter: {
      resetAll: 'Restablecer todo',
      sort: 'Clasificación',
      DEFAULT: 'Filtro',
      title: 'Filtro',
      'price-DEFAULT-EUR-GROSS_MODE': 'Precio',
      bestseller: 'Bestseller',
    },
    close: 'Cerrar',
    price: {
      DEFAULT: 'Precio',
      price_asc: 'Precio ascendente',
      price_desc: 'Precio descendente',
    },
    productView: {
      all: 'Todos',
      styleSwitcher: {
        title: 'Elegir estilo',
      },
    },
    noResults: {
      DEFAULT: 'No se encontraron coincidencias',
      headline: 'Lo sentimos, no hemos encontrado ningún resultado',
      content: 'No te rindas. Vuelve a intentarlo con otras palabras.',
      noInfoResults:
        'Actualmente, no hay más contenido disponible en este lugar.',
      noProductResult:
        'Hemos buscado por todas partes: lamentablemente no encontramos un producto adecuado.',
      searchInstead: '¿Quisiste decir',
    },
    pagination: {
      showPrevious: 'Ver anteriores',
      showMore: 'Ver más',
      productsSeen: '{amount} de {limit} productos vistos',
    },
    products: 'Productos',
    info: 'Información',
    product: {
      addToCart: 'añada',
      addToCartAtWishlist: 'Carrito',
      atCart: 'En el carrito',
      comingSoon: 'muy pronto',
      availableAt: 'disponible de',
      availableAgainAt: 'disponible nuevamente desde',
      soldOut: 'agotado',
      new: 'new',
      sale: 'sale',
      free: 'free',
      voucher: 'Cupón',
      property: {
        details: 'Detalles del Producto',
        features: 'Características',
        material: 'Material',
        safetyAndConformity: 'Seguridad y conformidad',
        responsibility: 'Responsabilidad',
        articleNo: 'Art.-Nr.',
        color: 'Color',
        content: 'Content',
        weight: 'Peso',
        volume: 'Volumen',
        size: 'Tamaño',
        sizeInfo: 'A/A/F',
        liter: 'litro',
      },
    },
    titlePageNotFound: 'Página no encontrada - 404',
  },
}

const translationConfigs = [baseTranslations, selfServiceOrderTranslations]

const translations = translationConfigs.reduce(
  (acc, curr) => {
    Object.entries(curr).forEach(([lang, terms]) => {
      if (!acc[lang]) {
        acc[lang] = {}
      }

      acc[lang] = { ...acc[lang], ...terms }
    })

    return acc
  },
  {} as Record<string, Record<string, string | Record<string, string>>>
)

export const t = (term: string, props: Record<string, string> = {}) =>
  translate(translations, term, props)
